import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-wrapper">
        <div className="footer-nav">
          <a href="/">Home</a>
          <a href='/services'>Services</a>
          <a href='/career'>Career</a>
          <a href="/about">About</a>
          <a href="/contact">Contact</a>

        </div>
        <div className="footer-copy">
          <p>&copy; {new Date().getFullYear()} Klyzen Ventures LLP. All rights reserved.</p>
          <p>Made with ❤️ India</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
